import React from 'react'
import './style.scss'

function Footer () {
  return (
    <footer className='footer'>
      <h4>Webpage designed and built by <a href='https://github.com/Oddert/oddert.github.io'>Robyn Veitch</a>.</h4>
      <p><i className='fa fa-copyright'></i> Copyright {new Date().getFullYear()} All rights reserved.</p>
    </footer>
  )
}

export default Footer
